import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import {withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../Form/utils";
import swal from "sweetalert";
import {array, object, string, boolean, required, mixed} from "yup";
import CourseFormFields from './CourseFormFields'

class CourseForm extends React.Component {

    render() {

        return <CourseFormFields {...this.props}/>

    }

}

const FormConfig = withFormik({
    mapPropsToValues: props => {
        return mergeWithDefault(props.values, {
            name_short: '',
            name: '',
            seminar: '',
            start: '',
            end: '',
            duration: '',
            qualification_id: '',
            qualification: null,
        });
    },

    validationSchema: () => {
        let rules = object().shape({
            name_short: string().required(
                i18n.get('validation.required', {attribute: i18n.get('courses.name_short')})
            ),
            name: string().required(
                i18n.get('validation.required', {attribute: i18n.get('courses.name')})
            ),
            seminar: string().required(
                i18n.get('validation.required', {attribute: i18n.get('courses.seminar')})
            ),
            start: string().required(
                i18n.get('validation.required', {attribute: i18n.get('courses.start')})
            ),
            end: string().required(
                i18n.get('validation.required', {attribute: i18n.get('courses.end')})
            ),
            // duration: string().required(
            //     i18n.get('validation.required', {attribute: i18n.get('courses.duration')})
            // ),
            // max_participants: string().required(
            //     i18n.get('validation.required', {attribute: i18n.get('courses.max_participants')})
            // ),
        });
    //
    //     // todo: company nur validieren wenn checkbox angehakt
    //     // company_name: string().required(
    //     //     i18n.get('validation.required', {attribute: i18n.get('contacts.first_name')})
    //     // )
    //
        return rules
    },

    handleSubmit: (values, {props}) => {
        axios.post(props.formUrl, values).then(() => {
            swal({
                icon: "success",
                title: i18n.get('courses.save_success'),
                text: i18n.get('courses.you_will_be_redirected'),
                timer: 4000,
            }).then(() => {
                window.location.href = props.redirectAfterSubmit
            })
        }).catch(() => {
            swal({
                icon: "error",
                title: i18n.get('courses.ajax_error'),
            })
        })
    },

    validateOnBlur: true

})(CourseForm)

const styles = theme => ({
    deleteButton: {
        // background: theme.colors.error
    }
});

export default withStyles(styles)(FormConfig)



// WEBPACK FOOTER //
// ./resources/assets/js/components/Courses/CourseForm.js